const HOTJAR_SITE_ID = 6780631;
const SCRIPT_ID = "hotjar-tracking-code";
const ALLOWED_HOSTS = new Set(["lemce.com", "www.lemce.com"]);

export function isHotjarHost() {
  return typeof window !== "undefined" && ALLOWED_HOSTS.has(window.location.hostname.toLowerCase());
}

export function loadHotjar() {
  if (!isHotjarHost()) return false;
  if (document.getElementById(SCRIPT_ID)) return true;

  window.hj = window.hj || function (...args) { (window.hj.q = window.hj.q || []).push(args); };
  window._hjSettings = { hjid: HOTJAR_SITE_ID, hjsv: 6 };

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://static.hotjar.com/c/hotjar-${HOTJAR_SITE_ID}.js?sv=6`;
  script.onerror = () => console.warn("Hotjar failed to load");
  document.head.appendChild(script);
  return true;
}

export function hotjarStateChange(path) {
  if (isHotjarHost() && typeof window.hj === "function") {
    window.hj("stateChange", path);
  }
}

export function hotjarEvent(name) {
  if (isHotjarHost() && typeof window.hj === "function") {
    window.hj("event", name);
  }
}
